import { CognitoUserAttribute } from "amazon-cognito-identity-js";

export const changeEmail = async (user, newEmail) => {
  return new Promise((resolve, reject) => {
    const attributes = [
      new CognitoUserAttribute({ Name: "email", Value: newEmail }),
    ];

    user.updateAttributes(attributes, (err, result) => {
      if (err) {
        return reject(err);
      }
      return resolve(result);
    });
  });
};

export default changeEmail;
